module.exports = __webpack_public_path__ + "img/EditHover.0b7cba5b.svg";